(() => {
  'use strict';

  const existingControl = '.quantity-stepper,.qty-stepper,.md-qty,.shop-qty,.cart-qty,.cart-quantity,.vc-cart-qty,.v-qty,.dusk-cart-item__qty,.quantity-ui-v13';

  function numericValue(input, fallback) {
    const parsed = Number.parseInt(input.value, 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function enhanceStandaloneQuantities(root = document) {
    const inputs = root.querySelectorAll('form input[type="number"][name="quantity"], form input[type="number"][name="updates[]"]');

    inputs.forEach((input) => {
      if (input.dataset.quantityUiV13 === 'true') return;
      if (input.closest(existingControl)) return;
      if (input.disabled || input.type !== 'number') return;

      const wrapper = document.createElement('div');
      wrapper.className = 'quantity-ui-v13';
      wrapper.dataset.quantityUiV13Wrapper = 'true';

      const minus = document.createElement('button');
      minus.type = 'button';
      minus.textContent = '−';
      minus.setAttribute('aria-label', 'Decrease quantity');

      const plus = document.createElement('button');
      plus.type = 'button';
      plus.textContent = '+';
      plus.setAttribute('aria-label', 'Increase quantity');

      const parent = input.parentNode;
      parent.insertBefore(wrapper, input);
      wrapper.append(minus, input, plus);
      input.dataset.quantityUiV13 = 'true';

      const defaultMin = input.name === 'updates[]' ? 0 : 1;
      const min = input.min !== '' ? Number.parseInt(input.min, 10) : defaultMin;
      const max = input.max !== '' ? Number.parseInt(input.max, 10) : Number.POSITIVE_INFINITY;
      const step = input.step && input.step !== 'any' ? Math.max(1, Number.parseInt(input.step, 10) || 1) : 1;

      const sync = () => {
        const value = numericValue(input, Math.max(defaultMin, min || defaultMin));
        minus.disabled = Number.isFinite(min) ? value <= min : false;
        plus.disabled = Number.isFinite(max) ? value >= max : false;
      };

      const changeBy = (delta) => {
        const current = numericValue(input, Math.max(defaultMin, min || defaultMin));
        let next = current + delta * step;
        if (Number.isFinite(min)) next = Math.max(min, next);
        if (Number.isFinite(max)) next = Math.min(max, next);
        input.value = String(next);
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        sync();
      };

      minus.addEventListener('click', () => changeBy(-1));
      plus.addEventListener('click', () => changeBy(1));
      input.addEventListener('input', sync);
      input.addEventListener('change', sync);
      sync();
    });
  }

  const init = () => enhanceStandaloneQuantities(document);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    enhanceStandaloneQuantities(event.target || document);
  });
})();
